import { useCanary } from '@bill/canary.react'

import { useExperimentTracking } from './ExperimentProvider'

export interface UseExperimentParams {
  experiment: string
  inputId: string
}

export const useExperiment = ({ experiment, inputId }: UseExperimentParams) => {
  const value = useCanary(experiment)

  const { track } = useExperimentTracking()

  track(experiment, inputId, value)

  if (typeof value !== 'object') {
    return {
      isInExperiment: false,
      behaviorName: 'EXPERIMENT_OFF',
    }
  }

  return {
    isInExperiment: value?.placement === 'QUALIFIED',
    behaviorName: value?.behaviorName ?? value?.placement,
  }
}

export default useExperiment
